import { css } from "styled-components";
import { IStyleProps } from "./interfaces";

export const MenuElement = css<IStyleProps>`
    position: relative;
    display: flex;
    align-items: center;
    margin: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: color 0.2s;
    vertical-align: top;
    color: ${p => p.theme.c.dark};


    svg {
        transition: fill 0.2s;
        fill: ${p => p.theme.c.dark};
    }

    :hover {
        color: ${p => p.theme.c.pale};

        svg {
            fill: ${p => p.theme.c.pale};
        }
    }

    ${p =>
        p.theme.xs(css`
            display: none;
        `)}

    ${p =>
        p.$isActive
            ? css`
                  color: ${p => p.theme.c.snowOnActive};

                  svg {
                      fill: ${p => p.theme.c.snowOnActive} !important;
                  }

                  &:hover {
                      color: ${p => p.theme.c.snowOnActive};

                      svg {
                          fill: ${p => p.theme.c.snowOnActive};
                      }
                  }
              `
            : undefined}

    ${p =>
        p.theme.sm.only(css`
            span:not([class^="i-"]) {
                display: none;
            }
        `)}
    
    &.HideLabelOnMd {
        ${p =>
            p.theme.md.only(css`
                span:not([class^="i-"]) {
                    display: none;
                }
            `)}
    }
`;
